const MSG = encodeURIComponent("Hello DaddyAnna247, I want my instant betting ID");

export const LINKS = {
  login: "#login",
  join: "#join",
  whatsapp: `https://wa.me/910000000000?text=${MSG}`,
  telegram: "https://t.me/daddyanna247",
  signal: "https://signal.me/#p/+910000000000",
};

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/14353482-e7b8-451f-849a-61062bc4e228/images/4772b90df1f36f87a4960545a16adbecc33c600477601c93e5f6c952fae8b4bd.jpeg",
  casino: "https://static.prod-images.emergentagent.com/jobs/14353482-e7b8-451f-849a-61062bc4e228/images/2a3f4a55c65fb6f452de99403181a42051f8e147c6876b06dd6f21ea6e658d1b.jpeg",
  football: "https://static.prod-images.emergentagent.com/jobs/14353482-e7b8-451f-849a-61062bc4e228/images/1dec742a8cf242e70b85a551c6ea96c9ab2cc383ca5b4c439c7ff3203712ea24.jpeg",
  aviator: "https://static.prod-images.emergentagent.com/jobs/14353482-e7b8-451f-849a-61062bc4e228/images/d6c9c80ef62e848d9d94674e621751ddd38961fcb039119e19e91b0942c6fca1.jpeg",
  tennis: "https://static.prod-images.emergentagent.com/jobs/14353482-e7b8-451f-849a-61062bc4e228/images/ba765bb2db760d97c8b0fe072c98df59e710235e5914ed20c5455b35143c2879.jpeg",
};

export const NAV_HREFS = ["/#exchange", "/#games", "/#how", "/#reviews", "/#payments", "/#faq"];

export const MATCHES = {
  cricket: [
    { teams: "Mumbai Royals vs Chennai Kings", league: "T20 League", time: "LIVE", back: ["1.84", "2.12"], lay: ["1.86", "2.16"] },
    { teams: "India vs Australia", league: "ODI Series", time: "19:30", back: ["1.62", "2.40"], lay: ["1.64", "2.46"] },
    { teams: "Kolkata Knights vs Delhi Capitals", league: "T20 League", time: "Tomorrow", back: ["1.95", "1.98"], lay: ["1.97", "2.02"] },
  ],
  football: [
    { teams: "Manchester Red vs London Blue", league: "Premier League", time: "LIVE", back: ["2.30", "3.10"], lay: ["2.34", "3.20"] },
    { teams: "Madrid White vs Barcelona", league: "La Liga", time: "23:00", back: ["2.05", "3.45"], lay: ["2.08", "3.55"] },
  ],
  tennis: [
    { teams: "Alcaraz vs Sinner", league: "ATP Masters", time: "LIVE", back: ["1.76", "2.18"], lay: ["1.78", "2.22"] },
    { teams: "Swiatek vs Sabalenka", league: "WTA Tour", time: "21:15", back: ["1.90", "1.96"], lay: ["1.92", "2.00"] },
  ],
};

export const GAMES_META = [
  { image: "hero", span: "md:col-span-2 md:row-span-2" },
  { image: "casino", span: "" },
  { image: "football", span: "" },
  { image: "tennis", span: "md:col-span-2" },
  { image: "aviator", span: "md:col-span-4" },
];

export const PAYMENTS = [
  { name: "UPI", logo: "/payments/upi.svg" },
  { name: "PhonePe", logo: "/payments/phonepe.svg" },
  { name: "Google Pay", logo: "/payments/gpay.svg" },
  { name: "Paytm", logo: "/payments/paytm.svg" },
  { name: "IMPS", logo: "/payments/imps.svg" },
  { name: "NEFT", logo: "/payments/neft.svg" },
];

export const FEATURE_ICONS = ["Zap", "ShieldCheck", "Headphones", "TrendingUp", "Smartphone", "Gift"];
